// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__vU2Q6","overflowing":"ReadFullNote_overflowing__3X2s0"};